import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // استيراد مكون التطبيق من App.js

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root') // سيتم ربط التطبيق بـ <div id="root"></div> في index.html
);
